export const environment = {
  production: false,
  envName: 'stg',
  version: '1.0.0',
  amplify: {
    Auth: {
      identityPoolId: 'ap-northeast-1:3935ad8c-2c37-481c-96ba-c468660b88bf',
      region: 'ap-northeast-1',
      userPoolId: 'ap-northeast-1_NBwOCqkcX',
      userPoolWebClientId: '4phg265hoe99hlbnt3u5m93aj7',
    },
    API: {
      endpoints: [
        {
          name: 'company',
          endpoint: 'https://b9uuca6d1i.execute-api.ap-northeast-1.amazonaws.com/stg'
        }
      ]
    },
    Storage: {
      myeventAttachment: {
        bucket: 'stg.unionnest.event.attachment',
        region: 'ap-northeast-1',
        level: 'private'
      }
    }
  },
  API_KEY: '1mAFE2R4X24VPb7SVKF0Lacr5Ls8kUfV2pXExONp',
  // AnalyticsTrackingId: 'G-0D69S7E2TH',
};
